<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container content text-center">
                    <a class="close-button" @click="$emit('close')"></a>
                    <div class="modal-header">
                        <div class="mobile-menu-logo"></div>
                    </div>
                    <div class="modal-body">
                        <div v-for="route in $store.state.menu.routes" class="mobile-menu-item" @click="$emit('close')">
                            <router-link :to="route.path" >{{ route.name }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    h2 {
        font-weight: 900;
    }

    p {
        font-size: 17px;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        height: 100%;
    }

    .modal-container {
        /*width: 300px;*/
        margin: 0 auto;
        height: 100%;
        padding: 108px 0;
        background-color: #f5f5f5;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
    }

    .close-button {
        position: absolute;
        display: block;
        right: 28px;
        top: 28px;
        background: url('../../assets/images/close.svg') no-repeat;
        background-size: contain;
        width: 14px;
        height: 14px;
        cursor: pointer;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media screen and (max-width: 992px) {
        .modal-container {
            width: auto !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/elements/MobileMenu.vue